import BaseValidator from "./BaseValidator";

const imageValidator = Object.create(BaseValidator);

// The imageValidator is only used when image should be updated
// It does not know of old image values, so it cannot be used to
// validate the current value
// It only checks if a required image should be removed
imageValidator.isValid = input => {
  if (input && input.remove) {
    return false;
  }

  return true;
};

imageValidator.isValidAndOptional = () => {
  return true;
};

export default imageValidator.init();
